import SectionHeading from "./SectionHeading";
import { focusTopics } from "@/mocks/home";

export default function FocusTopics() {
  return (
    <section id="focus" className="w-full bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          badge="Focus"
          title="51cg5 热议焦点 · 精选话题"
          desc="从热度榜中挑出讨论最集中的议题，先看短摘要，再决定要不要深挖。"
          linkText="浏览更多焦点"
          linkHref="#focus"
        />

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {focusTopics.map((topic) => (
            <a
              key={topic.id}
              href="#focus"
              className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={topic.image}
                  alt={topic.title}
                  title={`${topic.title} - 51cg5 热议焦点`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-2.5 py-1 text-[11px] font-bold text-background-50">
                  #{topic.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {topic.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{topic.summary}</p>
                <div className="mt-4 flex items-center gap-4 border-t border-background-200/70 pt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <span className="flex h-3.5 w-3.5 items-center justify-center text-accent-600">
                      <i className="ri-fire-line"></i>
                    </span>
                    {topic.heatText}
                  </span>
                  <span className="flex items-center gap-1">
                    <span className="flex h-3.5 w-3.5 items-center justify-center text-secondary-500">
                      <i className="ri-chat-3-line"></i>
                    </span>
                    {topic.comments} 讨论
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}